import type { ReactNode } from 'react';
import { Link, useInRouterContext } from 'react-router-dom';

/**
 * An in-app link that also works when the status components are rendered
 * outside a router — as the tests do with renderToStaticMarkup. Inside the
 * app it is a client-side navigation; outside, a plain anchor to the same
 * place.
 */
export function StatusLink({ to, className, title, children }: {
  to: string; className?: string; title?: string; children: ReactNode;
}) {
  const inRouter = useInRouterContext();
  return inRouter
    ? <Link to={to} className={className} title={title}>{children}</Link>
    : <a href={to} className={className} title={title}>{children}</a>;
}

/** Where a server's config lives, from any of the addresses the feeds carry. */
export const configPathFor = (address: string) => `/modpack-configs/${encodeURIComponent(address.trim().toLowerCase())}`;

/** The config list, searched for a cluster's servers. */
export const configListPathFor = (cluster: string) => `/modpack-configs?q=${encodeURIComponent(cluster)}`;
